import styled from 'styled-components';

export const OptionContainer = styled.div`
  margin-top: 20px;
  padding: 20px;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/CompareTiles/styles.js